import { render, staticRenderFns } from "./services-catalog.vue?vue&type=template&id=5e2b7e46&scoped=true"
import script from "./services-catalog.vue?vue&type=script&lang=ts"
export * from "./services-catalog.vue?vue&type=script&lang=ts"
import style0 from "./services-catalog.vue?vue&type=style&index=0&id=5e2b7e46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b7e46",
  null
  
)

export default component.exports